/* global jQuery, js_vars, elementorFrontend, google, SnazzyInfoWindow */

( function( $ ) {

	/*--------------------------------------------------------------------------------
	AJAX Live Search
	--------------------------------------------------------------------------------*/
	
	/**
	* Search setup and defaults
	**/

	let doAction = false,
	ajaxActive = false,
	firstSearch = true,
	emptyFirst = false;

	let form_data = [];
	const search_options = {
		empty_search: false,
		map_overlay: 'none',
		pagination: 'loadmore',
		page: 1,
		per_page: 8,
		post_type: 'page',
		tax_query: 'AND',
		template: 'card',
		tooltips: false
	};

	// Fetch current URL and any pre-search parameters
	const url = new URL(window.location);
	const params = new URLSearchParams(url.search);

	// Submit form on page ready for initial results
	$( document ).ready(function() {
		let form = $('#live-search-form');
		
		emptyFirst = form.data('emptyfirst');

		if( form.length ) {
			// Check for general filters in URL
			params.forEach((value, key) => {
				let fields = $(this).find('input:radio[name=' + key + ']');
				if( fields.length !== 0 ) {
					let currentField = fields.filter('[value=' + value + ']');
					currentField.prop('checked', true);

					let label = currentField.data('label');
					if( label.length !== 0 ) {
						currentField.parents('.form-dropdown').find('.dropdown-title').text(label);
					}
				}
			});

			// Check for search terms in URL
			let search = params.get('search');
			if ( search ) {
				$('#live-search').val(search);
			}

			// Initial form submit
			form.submit();
			firstSearch = false;
		}
	});


	/**
	* Handle form submission
	**/

	// Capture search form submissions
	$( document ).on( 'submit', '#live-search-form', function(e) {
		e.preventDefault();
		let $this = $(this);

		// Disable submit button
		if( ! firstSearch ) $this.find('.search-submit').attr('disabled', true);

		// Start search process
		submitLiveSearch($this);
	});

	// Begin live search process
	function submitLiveSearch( $this ) {
		// Setup form options
		if( $this.data('pagination') ) search_options.pagination = $this.data('pagination');
		if( $this.data('perpage') ) search_options.per_page = $this.data('perpage');
		if( $this.data('searchtype') ) search_options.post_type = $this.data('searchtype');
		if( $this.data('tax_query') ) search_options.tax_query = $this.data('tax_query');
		if( $this.data('template') ) search_options.template = $this.data('template');
		if( $this.data('tooltips') ) search_options.tooltips = $this.data('tooltips');
		if( $this.data('customorder') ) search_options.custom_order = $this.data('customorder');
		form_data = $this.serializeArray();

		// Reset impact details area when starting a new search
		if( search_options.post_type == 'impact' ) {
			resetImpactDetails();
		}

		// Add map overlay option if set
		if( search_options.template == 'interactive' ) {
			let overlay = form_data.find(o => o.name === 'map-overlay');
			if( overlay && overlay.value !== undefined && overlay.value !== 'none' ) {
				search_options.map_overlay = overlay.value;
			} else {
				search_options.map_overlay = 'none';
			}
		}

		// Update view URLs
		if( form_data.length !== 0 ) {
			$this.find('.search-view:not(.search-view-switch):not(.active)').each( function() {
				// Generate base URL
				let viewUrl = new URL( $(this).attr('href') );
				let baseViewUrl = `${viewUrl.protocol}//${viewUrl.hostname}${viewUrl.pathname}`;

				// Add populated options as URL variables
				let varCount = 0;
				form_data.map(function(entry, index) {
					if( entry.value !== '' ) {
						let urlVariable = (varCount == 0) ? '?' : '&';
						urlVariable += `${entry.name}=${entry.value}`;
						baseViewUrl += urlVariable;
						varCount++;
					}
				});

				// Add new href on element
				$(this).attr('href', baseViewUrl);
			});
		}

		// Reset timeout for new search if necessary
		if( doAction ) { clearTimeout( doAction ); }

		// Execute search, prevent stacked searches with timeout		
		if( firstSearch && emptyFirst ) {
			//
		} else {
			doAction = setTimeout( function() {
				_do_live_search();
			}, 250 );

			$('#hospital-map-overlay').fadeOut();
		}
	}


	/**
	* Handle live search functionality
	**/
	
	// Execute search
	function _do_live_search() {
		// Exit if AJAX is currently running
		if ( ajaxActive ) return false;

		$('.live-search-container').addClass('processing');
		
		// Modify options pre-run
		if( search_options.template == 'list' ) {
			search_options.per_page = 10;
		}

		// Run AJAX search
		ajaxActive = true;

		// Run AJAX
		$.when( _ajax_live_search() ).done(function( response ) {
			// Handle post-search cleanup & display
			_do_after_search( response );
		});
	}

	// Process AJAX
	function _ajax_live_search() {
		let data = {
			action: 'ajax_search',
			form_data: form_data,
			search_options: search_options
		};

		return $.ajax({
			type: 'POST',
			url: js_vars.ajaxurl,
			data: data,
			success: function(response) {
				// console.log(response);
				ajaxActive = false;
			},
			error: function(error) {
				console.log('error');
				ajaxActive = false;
			}
		});
	}

	// Handle results after search
	function _do_after_search( response ) {
		$('.live-search-container').removeClass('processing');

		_build_results( response );
		doAction = false;
	}

	// Display results
	function _build_results( response ) {
		let template = response.template;
		let post_type = response.post_type;
		
		if ( response.results.length > 0 && post_type !== 'impact' ) {
			if( template == 'interactive' ) {
				_destroy(1, 'interactive');

				// Parse coordinate JSON
				let markerJson = JSON.parse( response.results );

				// Clear map overlays, display new overlay if set
				clearMapData();
				if( search_options.map_overlay && search_options.map_overlay !== 'none' ) {
					displayMapData( search_options.map_overlay );
				}

				// Add markers, center map
				if( markerJson.length !== 0 ) {
					$.each(markerJson, function( marker_number, obj ) {
						createMapMarker( obj, window.map, marker_number );
					});

					centerMap( window.map );
				}

			} else {
				let page = response.pagination.page;
				_destroy( page );
				$('#live-search-count').text('Results: ' + response.numberposts);

				if( response.pagination.type == 'loadmore' ) {
					// Append results
					$('#live-search-results').append( response.results ).attr( 'class', 'view-' + template );

					// Setup load more button
					if( response.pagination.more ) {
						$('#loadmore-container').html('<a id="loadmore" href="#" data-page="' + ( response.pagination.page + 1 ) + '">View More</a>');
					} else {
						$('#loadmore-container').html('');
					}
				} else {
					// Replace results
					$('#live-search-results').html( response.results ).attr( 'class', 'view-' + template );

					if( response.pagination.type == 'pagination' ) {
						// Setup pagination
						let prevClasses = 'loadmore-pagination-prev loadmore-page';
						if( response.pagination.page > 1 ) { prevClasses += ' enabled'; }
						$('#loadmore-container').addClass('paged').html(`<span class="` + prevClasses + `" data-page="` + (response.pagination.page - 1) + `"><span class="loadmore-arrow-prev"></span> Prev</span>`);

						for( let n = 1; n <= response.pagination.total_pages; n++ ) {
							if( n == response.pagination.page ) {
								$('#loadmore-container').append('<span class="live-search-page active">' + n + '</span>');
							} else {
								$('#loadmore-container').append('<a href="#" class="live-search-page loadmore-page enabled" data-page="' + n + '">' + n + '</a>');
							}
						}

						let nextClasses = 'loadmore-pagination-next loadmore-page';
						if( response.pagination.page < response.pagination.total_pages ) { nextClasses += ' enabled'; }
						$('#loadmore-container').append(`<span class="` + nextClasses + `" data-page="` + (response.pagination.page + 1) + `">Next <span class="loadmore-arrow-next"></span></span>`);
					}
				}
			}

		// No results
		} else {
			if( template == 'interactive' ) {
				_destroy(1, 'interactive');

				if( post_type == 'impact' ) {
					clearMapData();
					if( search_options.map_overlay && search_options.map_overlay !== 'none' ) {
						displayMapData( search_options.map_overlay );
					}
				}
				
				// resetImpactDetails('No results found for this combination of filters.');
			} else {
				_destroy();
				$('#live-search-count').text('Results: 0');
				$('#live-search-results').append('<p>No results found.</p>');
			}
		}
	}

	// Destroy search results and/or button
	function _destroy( page = 1, style = 'standard' ) {
		if( style == 'interactive' ) {
			// Clear open info windows
			google.maps.event.trigger( window.map, 'click' );

			// Clear current markers
			if( window.map.markers ) {
				for (let i = 0; i < window.map.markers.length; i++) {
					window.map.markers[i].setMap(null);
				}
			}
			window.map.markers = [];

		} else {
			if( page !== 1 ) {
				$('#loadmore').remove();
			} else {
				$('#live-search-results').empty();
			}
		}
	}


	/**
	 * Handle form interactivity
	 **/

	// Handle load more button
	$( document ).on( 'click', '#loadmore', function(e) {
		e.preventDefault();
		let $this = $(this);

		search_options.page = $this.data('page');

		if ( doAction ) { clearTimeout( doAction ); }

		doAction = setTimeout( function() {
			_do_live_search();
		}, 250 );
	});

	// Handle pagination clicks
	$( document ).on( 'click', '.loadmore .loadmore-page', function(e) {
		e.preventDefault();
		let $this = $(this);

		if( $this.hasClass('enabled') ) {
			search_options.page = $this.data('page');
			if ( doAction ) { clearTimeout( doAction ); }
			doAction = setTimeout( function() {
				_do_live_search();
			}, 250 );
		}
	});		

	// Handle view switching
	$(document).on( 'click', '.search-view-switch', function(e) {
		e.preventDefault();

		let target = $( e.currentTarget ),
		template = target.data('template');
		search_options.template = template;

		$('.search-view-switch').removeClass('active').filter(target).addClass('active');
		$('#live-search-form').data('template', template);
		
		if ( doAction ) { clearTimeout( doAction ); }
		doAction = setTimeout( function() {
			_do_live_search();
		}, 250 );
	});

	// Submit form on dropdown change or submit click
	$(document).on( 'change', '.live-search-form--liveclick .search-filter', function(e) {
		// Only reset other fields if this dropdown isn't set up as a child
		if( ! $(this).hasClass('relationship-child') && ! $(this).hasClass('relationship-parent') ) {
			// Reset all other values
			$('.search-filter').not($(e.currentTarget)).each(function(){
				$(this).find('select').val("");
				$(this).find('select').prop('selectedIndex',0);

				// Reset radios
				let radio = $(this).find('input:radio');
				radio.prop('checked', false);

				// Reset labels if applicable
				let dropdown_label = radio.data('label');
				radio.parents('.form-dropdown').find('.dropdown-title').text(dropdown_label);
			});
		}

		// Reset search box
		$('#live-search').not($(e.target)).val('');
		$('#live-search-form').submit();
	});

	// Enable submit button on form change
	$(document).on( 'change', '.live-search-form', function(e) {
		$(this).find('.search-submit').attr('disabled', false);
	})


/*--------------------------------------------------------------------------------
Interactive Hospital Map
--------------------------------------------------------------------------------*/

	/**
	 * Prep map styles
	 */

	let primary_style = [
		{
			"featureType": "administrative",
			"elementType": "all",
			"stylers": [
				{
					"saturation": "-100"
				}
			]
		},
		{
			"featureType": "administrative.province",
			"elementType": "all",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "administrative.province",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"color": "#3b3b3b"
				},
				{
					"visibility": "on"
				},
				{
					"weight": 4
				}
			]
		},
		{
			"featureType": "landscape",
			"elementType": "all",
			"stylers": [
				{
					"saturation": -100
				},
				{
					"lightness": 65
				},
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "poi",
			"elementType": "all",
			"stylers": [
				{
					"saturation": -100
				},
				{
					"lightness": "50"
				},
				{
					"visibility": "simplified"
				}
			]
		},
		{
			"featureType": "road",
			"elementType": "all",
			"stylers": [
				{
					"saturation": "-100"
				}
			]
		},
		{
			"featureType": "road.highway",
			"elementType": "all",
			"stylers": [
				{
					"visibility": "simplified"
				}
			]
		},
		{
			"featureType": "road.arterial",
			"elementType": "all",
			"stylers": [
				{
					"lightness": "30"
				}
			]
		},
		{
			"featureType": "road.local",
			"elementType": "all",
			"stylers": [
				{
					"lightness": "40"
				}
			]
		},
		{
			"featureType": "transit",
			"elementType": "all",
			"stylers": [
				{
					"saturation": -100
				},
				{
					"visibility": "simplified"
				}
			]
		},
		{
			"featureType": "water",
			"elementType": "geometry",
			"stylers": [
				{
					"hue": "#ffff00"
				},
				{
					"lightness": -25
				},
				{
					"saturation": -97
				}
			]
		},
		{
			"featureType": "water",
			"elementType": "labels",
			"stylers": [
				{
					"lightness": -25
				},
				{
					"saturation": -100
				}
			]
		}
	];

	let impact_style = [
		{
			"featureType": "all",
			"elementType": "labels",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "all",
			"elementType": "labels.text.fill",
			"stylers": [
				{
					"saturation": 36
				},
				{
					"color": "#333333"
				},
				{
					"lightness": 40
				}
			]
		},
		{
			"featureType": "all",
			"elementType": "labels.text.stroke",
			"stylers": [
				{
					"visibility": "on"
				},
				{
					"color": "#ffffff"
				},
				{
					"lightness": 16
				}
			]
		},
		{
			"featureType": "all",
			"elementType": "labels.icon",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "administrative",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"color": "#fefefe"
				},
				{
					"lightness": 20
				}
			]
		},
		{
			"featureType": "administrative",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"color": "#fefefe"
				},
				{
					"lightness": 17
				},
				{
					"weight": 1.2
				}
			]
		},
		{
			"featureType": "administrative",
			"elementType": "labels",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "landscape",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#F4F7FA"
				}
			]
		},
		{
			"featureType": "landscape",
			"elementType": "labels",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "poi",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#f5f5f5"
				},
				{
					"lightness": 21
				}
			]
		},
		{
			"featureType": "poi",
			"elementType": "labels",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "poi.park",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#dedede"
				},
				{
					"lightness": 21
				}
			]
		},
		{
			"featureType": "poi.park",
			"elementType": "labels",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "road",
			"elementType": "all",
			"stylers": [
				{
					"lightness": "0"
				}
			]
		},
		{
			"featureType": "road",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"color": "#e5e8eb"
				}
			]
		},
		{
			"featureType": "road",
			"elementType": "labels",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "road.highway",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"lightness": 17
				}
			]
		},
		{
			"featureType": "road.highway",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"color": "#ffffff"
				},
				{
					"lightness": 29
				},
				{
					"weight": 0.2
				}
			]
		},
		{
			"featureType": "road.arterial",
			"elementType": "geometry",
			"stylers": [
				{
					"lightness": 18
				}
			]
		},
		{
			"featureType": "road.local",
			"elementType": "geometry",
			"stylers": [
				{
					"lightness": 16
				}
			]
		},
		{
			"featureType": "transit",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#f2f2f2"
				},
				{
					"lightness": 19
				}
			]
		},
		{
			"featureType": "transit",
			"elementType": "labels",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "water",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#e9e9e9"
				},
				{
					"lightness": 17
				}
			]
		}
	];


	/**
	 * Initialize Google Maps
	 */
	function initializeMap( $map_element ) {
		// Prep initial map setup
		let mapStyle = primary_style;
		if( search_options.post_type == 'impact' ) {
			mapStyle = impact_style;
		}

		let mapArgs = {
			zoom : 7,
			mapTypeId : google.maps.MapTypeId.ROADMAP,
			disableDefaultUI: true,
			center: { lat: 37.808940, lng: -85.786821 },
			styles: mapStyle
		};

		window.map = new google.maps.Map( $map_element[0], mapArgs );
		window.map.markers = [];

		// Prep overlay styling, hover/click tracking
		window.map.data.setStyle(function(feature) {
			let color = '#D0EBFF',
			opacity = 0,
			hover = feature.getProperty('hover'),
			clicked = feature.getProperty('clicked');

			if( clicked ) {
				color = '#7CAFDB';
				opacity = .9;
			} else if( hover && ! clicked ) {
				opacity = .7;
			}
			
			return ({
				clickable: true,
				fillColor: color,
				fillOpacity: opacity,
				strokeColor: '#0E2152',
				strokeWeight: 1,
			});
		});

		// Manage overlay click and hover events
		window.map.data.addListener('click', function(event) {
			clearMapInteraction();
			event.feature.setProperty('clicked', true);

			if( search_options.post_type == 'impact' ) {
				_do_impact_district( event.feature );
			}
		});

		window.map.data.addListener('mouseover', function(event) {
			event.feature.setProperty('hover', true);
		});

		window.map.data.addListener('mouseout', function(event) {
			event.feature.setProperty('hover', false);
		});

		// Setup custom zoom buttons
		let zoomButtonsContainer = document.createElement('div'),
		zoomButtons = new addZoomButtons( zoomButtonsContainer, window.map );
		zoomButtonsContainer.index = 1;
		window.map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push( zoomButtonsContainer );

		// Return map instance.
		return window.map;
	}

	/**
	 * Display GeoJSON as data overlay
	 */
	function displayMapData( $data_name ) {
		window.map.data.loadGeoJson( js_vars.themeurl + '/map/' + $data_name + '.json' );
	}
	
	/**
	 * Clear all active map interactions and overlays
	 */
	function clearMapData() {
		clearMapInteraction();

		window.map.data.forEach(function( feature ) {
			window.map.data.remove(feature);
		});
	}

	/**
	 * Center map based on markers
	 */
	function centerMap( map ) {
		// Create map boundaries from all map markers
		let bounds = new google.maps.LatLngBounds();
		map.markers.forEach(function( marker ){
			bounds.extend({
				lat: marker.position.lat(),
				lng: marker.position.lng()
			});
		});

		

		// Case: Single marker
		if( map.markers.length == 1 ){
			map.setCenter( bounds.getCenter() );

		// Case: Multiple markers
		} else{
			// map.fitBounds( bounds, {bottom:30,top: 50,right:40,left:40} );
			// map.fitBounds( bounds );
			// map.setZoom(map.getZoom() + .5);
		}
	}

	/**
	 * Add marker to Google Map
	 */
	function createMapMarker( $marker, map, result_number ) {
		// Prep marker coordinates and popup details
		let address = $marker.address,
		details = $marker.details,
		lat = $marker.lat,
		lng = $marker.lng,
		marker_number = result_number+1,
		tooltip = false;

		if( "name" in $marker ) {
			tooltip = $marker.name;
		}

		// Clean lat & lng
		let latLng = {
			lat: parseFloat( lat ),
			lng: parseFloat( lng )
		};

		if( ! isNaN(latLng.lat) && ! isNaN(latLng.lng) ) {

			/**
			 * Setup marker icon
			 */
			let iconSvgRaw,
			iconSvg,
			iconSvgHover,
			iconSvgOpen;
			
			let icon_default = { anchor: new google.maps.Point(13, 13)},
			icon_hover = { anchor: new google.maps.Point(13, 13)},
			icon_open = { anchor: new google.maps.Point(13, 13)};

			iconSvgRaw = (fill) => `
			<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
			viewBox="0 0 22 22" style="enable-background:new 0 0 22 22;" xml:space="preserve" width="22" height="22">
				<path fill="${fill}" d="M17.5,0.4h-13c-2.3,0-4.2,1.9-4.2,4.2v13c0,2.3,1.9,4.2,4.2,4.2h13c2.3,0,4.2-1.9,4.2-4.2v-13
					C21.6,2.2,19.8,0.4,17.5,0.4z"/>
				<path fill="#000000" d="M17.5,0h-13C2,0,0,2,0,4.5v13C0,20,2,22,4.5,22h13c2.5,0,4.5-2,4.5-4.5v-13C22,2,20,0,17.5,0z M21.6,17.5
					c0,2.3-1.9,4.2-4.2,4.2h-13c-2.3,0-4.2-1.9-4.2-4.2v-13c0-2.3,1.9-4.2,4.2-4.2h13c2.3,0,4.2,1.9,4.2,4.2V17.5z"/>
				<path fill="#FFFFFF" d="M16.9,3c-0.1,0-0.3-0.1-0.5-0.1c-0.2,0-0.5,0-0.8,0c-0.3,0-0.6,0-0.8,0C14.6,3,14.5,3,14.3,3
					c-0.1,0-0.2,0.1-0.3,0.2C14,3.3,14,3.3,14,3.4v5.9H8V3.4c0-0.1,0-0.2-0.1-0.2c0-0.1-0.1-0.1-0.3-0.2C7.5,3,7.4,3,7.2,2.9
					c-0.2,0-0.5,0-0.8,0c-0.3,0-0.6,0-0.8,0C5.4,3,5.2,3,5.1,3C5,3.1,4.9,3.1,4.8,3.2C4.8,3.3,4.7,3.3,4.7,3.4v15.2c0,0.1,0,0.2,0.1,0.2
					C4.9,18.9,5,18.9,5.1,19c0.1,0,0.3,0.1,0.5,0.1c0.2,0,0.5,0,0.8,0c0.3,0,0.6,0,0.8,0C7.4,19,7.5,19,7.7,19c0.1,0,0.2-0.1,0.3-0.2
					C8,18.7,8,18.7,8,18.6v-6.5h6v6.5c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.3,0.2c0.1,0,0.3,0.1,0.5,0.1c0.2,0,0.5,0,0.8,0
					c0.3,0,0.6,0,0.8,0c0.2,0,0.4-0.1,0.5-0.1c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.1-0.1,0.1-0.2V3.4c0-0.1,0-0.2-0.1-0.2
					C17.1,3.1,17,3.1,16.9,3z"/>
			</svg>`;
			
			iconSvg = iconSvgRaw('#0B77BD');
			iconSvgHover = iconSvgRaw('#25408F');
			iconSvgOpen = iconSvgRaw('#25408F');
			
			// Assign marker SVG
			icon_default.url = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(iconSvg);
			icon_hover.url = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(iconSvgHover);
			icon_open.url = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(iconSvgOpen);
			
			// Add marker
			let marker = new google.maps.Marker({
				position: latLng,
				map: map,
				icon: icon_default,
				icon_default: icon_default,
				icon_hover: icon_hover,
				icon_open: icon_open,
				marker_number: marker_number,
				open: false,
				post_id: $marker.post_id,
				tooltip: tooltip
			});

			// Populate main hospital map popup data
			if( details == 'popup' ) {
				let name = $marker.name,
				ceo = $marker.ceo,
				phone = $marker.phone,
				url = $marker.url;

				// Build popup markup
				let windowContent = `<div class="hospital-info-container"><div class="hospital-info"><h3 class="title">` + name + `</h3>`;
				if( ceo !== '' ) { windowContent += `<div class="ceo">CEO: ` + ceo + `</div>`; }
				if( address !== '' ) { windowContent += `<div class="address">` + address + `</div>`; }
				if( phone !== '' ) { windowContent += `<div class="phone">` + phone + `</div>`; }
				if( url !== '' ) { windowContent += `<a href="` + url + `" class="url" target="_blank">Visit Website</a>`; }



						windowContent += `</div></div>`;

				// Init info popup
				let infoWindow = new SnazzyInfoWindow({
					marker: marker,
					wrapperClass: 'map-listing-info',
					showCloseButton: true,
					openOnMarkerMouseOver: false,
					closeOnMarkerMouseOut: false,
					closeWhenOthersOpen: true,
					closeOnMapClick: true,
					pointer: false,
					shadow: false,
					border: false,
					offset: {
						top: '0',
						left: '16px'
					},
					content: windowContent
				});
			}



			if( details == 'popupjobsearch' ) {
				let name = $marker.name,
				ceo = $marker.ceo,
				phone = $marker.phone,
				url = $marker.url,
				url02 = $marker.url02;

				// Build popup markup
				let windowContent = `<div class="hospital-info-container"><div class="hospital-info"><h3 class="title">` + name + `</h3>`;			
				if( address !== '' ) { windowContent += `<div class="address">` + address + `</div>`; }			
				if( url !== '' ) { windowContent += `<a href="` + url + `" class="url" target="_blank">Visit Recruitment Website</a>`; }
                                if( url02 !== '' ) { windowContent += `<a href="` + url02 + `" class="url" target="_blank">Visit Recruitment Website #2</a>`; }


						windowContent += `</div></div>`;

				// Init info popup
				let infoWindow = new SnazzyInfoWindow({
					marker: marker,
					wrapperClass: 'map-listing-info',
					showCloseButton: true,
					openOnMarkerMouseOver: false,
					closeOnMarkerMouseOut: false,
					closeWhenOthersOpen: true,
					closeOnMapClick: true,
					pointer: false,
					shadow: false,
					border: false,
					offset: {
						top: '0',
						left: '16px'
					},
					content: windowContent
				});
			}



			google.maps.event.addListener(marker, 'click', function() {
				clearMapInteraction();

				this.setOptions({open: true, zIndex: 200});
				this.setIcon(this.icon_open);

				if( details !== 'popup') {
					_do_impact_hospital( this.post_id, this.marker_number );
				}
			});

			google.maps.event.addListener(marker, "mouseover", function(e) {
				if( this.open !== true ) {
					this.setIcon(this.icon_hover);
				}

				if( search_options.tooltips === true ) {
					createTooltip(e, this.tooltip);
				}
			});

			google.maps.event.addListener(marker, "mouseout", function(e) {
				if( this.open !== true ) {
					this.setIcon(this.icon_default);
				}

				if( search_options.tooltips === true ) {
					deleteTooltip(e);
				}
			});

			// Append to reference for later use
			map.markers.push( marker );
		}
	}


	/**
	 * Manage map tooltips
	 */
	let tipObj = null;
	let offset = {
		x: 20,
		y: 20
	};

	function createTooltip( event, data ) {
		// Only show tooltips on desktop
		if( window.screen.width > 768 ) {
			if ( ! tipObj && event ) {
				// Create tooltip element
				tipObj = document.createElement("div");
				tipObj.style.background = "#fff";
				tipObj.style.borderRadius = "5px";
				tipObj.style.boxShadow = "0 3px 3px rgba(0,0,0,.2)";
				tipObj.style.fontFamily = "Arial,Helvetica";
				tipObj.style.fontSize = "12px";
				tipObj.style.lineHeight = ".9";
				tipObj.style.padding = "6px";
				tipObj.style.textAlign = "center";
				tipObj.style.transform = "translate(-50%, calc(-100% - 8px))";
				tipObj.style.width = '120px';
				tipObj.style.zIndex = "99";
				tipObj.innerHTML = data;

				// Position tooltip
				tipObj.style.position = "fixed";
				tipObj.style.top = event.domEvent.clientY + "px";
				tipObj.style.left = event.domEvent.clientX + "px";

				// Add tooltip
				document.body.appendChild(tipObj);
			}
		}
	}
	
	function deleteTooltip(event) {
		if ( tipObj ) {
			document.body.removeChild(tipObj);
			tipObj = null;
		}
	}


	/**
	 * Add zoom controls to map
	 */
	function addZoomButtons( zoomButtonsContainer, map ) {
		// Create elements for zoom controls	
		let zoomWrapper = document.createElement('div');
		let zoomInButton = document.createElement('div'),
		zoomOutButton = document.createElement('div');
		
		// Style elements
		zoomButtonsContainer.style.padding = '0 0 0 12px';
		zoomInButton.className = 'map__zoom-in';
		zoomOutButton.className = 'map__zoom-out';

		// Add buttons to container
		zoomButtonsContainer.appendChild( zoomWrapper );
		zoomWrapper.appendChild( zoomInButton );
		zoomWrapper.appendChild( zoomOutButton );

		// Add event listeners
		zoomInButton.addEventListener( 'click', function() {
			map.setZoom( map.getZoom() + 1 );
		});

		zoomOutButton.addEventListener( 'click', function() {
			map.setZoom( map.getZoom() - 1 );
		});  
	}

	/**
	 * Render map on page load
	 */
	$(document).ready(function(){
		if( $('#hospital-map').length ) {
			let map = initializeMap( $('#hospital-map') );

			if( search_options.map_overlay && search_options.map_overlay !== 'none' ) {
				displayMapData( search_options.map_overlay );
			}
		}
	});


/*--------------------------------------------------------------------------------
Impact Map
--------------------------------------------------------------------------------*/

	/**
	 * Clear out all active markers and regions on the map
	 */
	function clearMapInteraction() {
		window.map.markers.forEach(function( marker_entry ){
			marker_entry.setOptions({open: false});
			marker_entry.setIcon(marker_entry.icon_default);
		});

		window.map.data.forEach(function( feature ) {
			feature.setProperty('clicked', false);
		});
	}


	/**
	* Handle district search functionality
	**/
	
	// Execute impact district search
	function _do_impact_district( feature ) {
		let feature_info = {
			map_overlay: search_options.map_overlay
		};

		feature.forEachProperty( function( value, key ) {
			feature_info[key] = value;
		});
		
		$.when( _fetch_impact_district( feature_info ) ).done(function( response ) {
			// Handle post-search cleanup & display
			_build_impact_details( response, 'district' );
		});
	}

	// Process impact district AJAX
	function _fetch_impact_district( feature_info ) {
		let data = {
			action: 'ajax_impact_district',
			feature_info: feature_info
		};

		return $.ajax({
			type: 'POST',
			url: js_vars.ajaxurl,
			data: data,
			success: function(response) {
				// console.log(response);
				// ajaxActive = false;
			},
			error: function(error) {
				console.log('error');
				// ajaxActive = false;
			}
		});
	}

	
	/**
	* Handle impact hospital search functionality
	**/

	// Execute impact hospital search
	function _do_impact_hospital( post_id, marker_number ) {
		$.when( _fetch_impact_hospital( post_id, marker_number ) ).done(function( response ) {
			// Handle post-search cleanup & display
			_build_impact_details( response, 'hospital' );
		});
	}

	// Fetch impact hospital details by post id
	function _fetch_impact_hospital( post_id, marker_number ) {
		let data = {
			action: 'ajax_impact_hospital',
			marker_number: marker_number,
			post_id: post_id
		};

		return $.ajax({
			type: 'POST',
			url: js_vars.ajaxurl,
			data: data,
			success: function(response) {
				// console.log(response);
				// ajaxActive = false;
			},
			error: function(error) {
				console.log('error');
				// ajaxActive = false;
			}
		});
	}

	
	/**
	* Manage impact hospital and district detail display
	**/
	function _build_impact_details( response, detail_type ) {
		$('.tabs-entry').removeClass('active');
		$('#tab-details-' + detail_type).addClass('active');
		
		$('#impact-details').html( response );
	}

	function resetImpactDetails( message = false ) {
		let details = `<div class="details__empty-box"><span class="empty-box__text">`;
		if( message ) { details += `<span class="message">${message}</span>`; }
		details += `<span>Make a selection to view details of the area.</span></span></div>`
		$('#impact-details').html(details);
	}
	

} )( jQuery );